<template>
  <div class="boxs">
    <el-row :gutter="20">
      <el-form ref="dataForm" :model="selectList">
        <el-col
          v-for="item in formList"
          :key="item.prop"
          :span="6"
          class="bottom"
        >
          <el-form-item :prop="item.prop">
            <el-input
              v-model="selectList[item.prop]"
              :placeholder="item.placeholder"
              :maxlength="item.maxlength"
              @input="changeVal($event, item.prop)"
              @change="formatTram($event, item.prop)"
              clearable
              v-if="item.type === 'input'"
              size="small"
            />

            <el-select
              size="small"
              clearable
              v-if="item.type === 'select'"
              v-model="selectList[item.prop]"
              :placeholder="item.placeholder"
              :disabled="item.List.length === 0"
            >
              <el-option
                v-for="ele in item.List"
                :key="ele.value"
                :label="ele.label"
                :value="ele.value"
              >
              </el-option>
            </el-select>

            <el-date-picker
              size="small"
              v-if="item.type === 'date'"
              v-model="selectList[item.prop]"
              type="datetimerange"
              range-separator="至"
              start-placeholder="直播开始日期"
              end-placeholder="直播结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              clearable
            />
          </el-form-item>
        </el-col>
        <div class="bottom" style="float: right">
          <el-button class="but" @click="submit" type="primary">
            查询</el-button
          >
          <el-button class="but" @click="empty"> 重置</el-button>
        </div>
      </el-form>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "dataForm",
  props: ["searchList"],
  computed: {
    selectList: {
      get() {
        return this.searchList;
      },
      set(val) {
        this.$emit("update:searchList", val);
      },
    },
  },
  data() {
    return {
      formList: [
        {
          prop: "externalId",
          type: "input",
          maxlength: 50,
          placeholder: "请输入直播ID进行检索",
        },
        {
          prop: "publisher",
          type: "input",
          maxlength: 200,
          placeholder: "请输入主讲人",
        },
        {
          prop: "contentName",
          type: "input",
          maxlength: 200,
          placeholder: "请输入直播标题",
        },
        {
          prop: "liveTime",
          type: "date",
        },
        {
          prop: "liveStatus",
          type: "select",
          placeholder: "请输入直播状态",
          List: [
            {
              label: "直播中",
              value: 1,
            },
            {
              label: "已结束",
              value: 2,
            },
            {
              label: "回放中",
              value: 3,
            },
            {
              label: "预告",
              value: 0,
            },
          ],
        },
        {
          prop: "liveMark",
          type: "select",
          placeholder: "请输入直播形式",
          List: [
            {
              label: "正式",
              value: 1,
            },
            {
              label: "测试",
              value: 0,
            },
          ],
        },
      ],
    };
  },
  methods: {
    empty() {
      this.$refs["dataForm"].resetFields();
      this.submit();
    },
    submit() {
      this.$emit("onSubmit");
    },
    changeVal(val, name) {
      if (name === "externalId" && val) {
        this.selectList.externalId = val.replace(/[^\d]/g, "");
      }
    },
    formatTram(val, name) {
      this.selectList[name] = val.trim();
    },
  },
};
</script>

<style lang="scss" scoped>
.boxs {
  width: 100%;
  height: auto;
  padding: 20px;
  background-color: #fff;
  margin-bottom: 10px;

  .bottom {
    margin-top: 14px;

    .but {
      float: right;
      margin-left: 10px;
      padding-top: 10px !important;
    }
  }

  .el-input,
  .el-select {
    width: 100%;
  }
  :deep(.el-form-item__content) {
    line-height: normal;
  }
  :deep(.el-date-editor) {
    width: 100%;
  }
  :deep(.el-range-separator) {
    width: 20px !important;
  }
}
</style>
